import React, { memo, useRef } from 'react';
import FormattedHtml from 'components/common/FormattedHtml';

interface IProps {
  description: string;
  variant?: string;
}

/* eslint-disable react/no-danger */
const EventDescription: React.FC<IProps> = ({ description, variant = 'body1' }) => {
  const ref: any = useRef<HTMLDivElement>(null);

  return (
    <div>
      <FormattedHtml content={description} ref={ref} variant={variant} />
    </div>
  );
};

export default memo(EventDescription);
